import { render } from "./AnomalyBreakdownComponent.vue?vue&type=template&id=99bd81b6&scoped=true"
import script from "./AnomalyBreakdownComponent.vue?vue&type=script&lang=js"
export * from "./AnomalyBreakdownComponent.vue?vue&type=script&lang=js"

import "./AnomalyBreakdownComponent.vue?vue&type=style&index=0&id=99bd81b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99bd81b6"]])

export default __exports__